module.exports = __webpack_public_path__ + "static/service-visual-45f25bd6cf12d724411d86d8845b97d2.png";